/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_H1Inputs */

const es_faq_h1 = /** @type {(inputs: Faq_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas frecuentes`)
};

const gl_faq_h1 = /** @type {(inputs: Faq_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas frecuentes`)
};

const en_faq_h1 = /** @type {(inputs: Faq_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently asked questions`)
};

/**
* | output |
* | --- |
* | "Frequently asked questions" |
*
* @param {Faq_H1Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_h1 = /** @type {((inputs?: Faq_H1Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_H1Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_faq_h1(inputs)
	if (locale === "en") return en_faq_h1(inputs)
	return es_faq_h1(inputs)
});